import RecaptchaWrapper from "./RecaptchaWrapper"
import ReCAPTCHA from "./Recaptcha"

export default RecaptchaWrapper
export { ReCAPTCHA }

// Everything in this folder is a copy-paste of https://github.com/dozoisch/react-google-recaptcha/pull/239
